<template>

  <!--<div class="movie">
    <div class="movie-container">
      <img class="movie-title" src="./img/movie-title.png">
      <img class="movie-img" src="./img/movie-dammy.png">
    </div>

  </div>-->

  <div class="new-topics-box">
    <div class="new-topics-title">
      店舗OPEN情報
    </div>
    <div class="scroll">
      <table class="new-topic-table">
        <tbody>
          <tr class="new-topic-row" v-for="topic in newTopics" :key="topic">
            <td class="new-date">{{ topic.date }}</td> 
            <td class="new-shop">{{ topic.shopName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";// eslint-disable-line

export default {
  name: 'NewTopics',
  components: {
    VuePerfectScrollbar// eslint-disable-line
  },
  data: function(){
    return {
      newTopics:[
        {date:'22/4/1',shopName:'セルフエステエンリケ新宿三丁目店OPEN！'},
        {date:'22/2/26',shopName:'セルフエステエンリケ仙台店リニューアルOPEN！'},
        {date:'22/1/12',shopName:'セルフエステエンリケ天文館店リニューアルOPEN！'},
        {date:'21/11/27',shopName:'セルフエステエンリケ横浜関内店OPEN！'},
        {date:'21/9/1',shopName:'セルフエステエンリケ浜松町駅前店OPEN！'},
        {date:'21/8/28',shopName:'セルフエステエンリケ岡崎店OPEN！'},
        {date:'21/8/28',shopName:'セルフエステエンリケ自由が丘店OPEN！'},
        {date:'21/8/21',shopName:'セルフエステエンリケ仙台泉店OPEN！'},
        {date:'21/8/20',shopName:'セルフエステエンリケ根室店OPEN！'},
        {date:'21/7/24',shopName:'セルフエステエンリケ近江八幡店OPEN！'},
        {date:'21/7/6',shopName:'セルフエステエンリケ札幌北店OPEN！'},
        {date:'21/7/1',shopName:'セルフエステエンリケ伊賀上野・由利本荘・松山福音寺店OPEN！'},
        {date:'21/6/28',shopName:'セルフエステエンリケ沼津店OPEN！'},
        {date:'21/6/15',shopName:'セルフエステエンリケ青森・松阪店OPEN！'},
        {date:'21/6/14',shopName:'セルフエステエンリケ大宮店OPEN！'},
        {date:'21/6/5',shopName:'セルフエステエンリケ静岡葵・浜松店OPEN！'},
        {date:'21/6/1',shopName:'セルフエステエンリケ宇部店OPEN！'},
        {date:'21/5/31',shopName:'セルフエステエンリケ八幡西店OPEN！'},
        {date:'21/5/21',shopName:'セルフエステエンリケ天神店OPEN！'},
        {date:'21/5/20',shopName:'セルフエステエンリケ堺三国ヶ丘・那覇松山店OPEN！'},
        {date:'21/5/19',shopName:'セルフエステエンリケ鳥取店OPEN！'},
        {date:'21/5/13',shopName:'セルフエステエンリケ阪急塚口店OPEN！'},
        {date:'21/5/8',shopName:'セルフエステエンリケ飯田店OPEN！'},
        {date:'21/5/7',shopName:'セルフエステエンリケ北千住店OPEN！'},
        {date:'21/5/1',shopName:'セルフエステエンリケ天白区店OPEN！'},
        {date:'21/4/26',shopName:'セルフエステエンリケ可児店・鈴鹿店・明石大久保店・鹿大前店OPEN！'},
        {date:'21/4/24',shopName:'セルフエステエンリケ小田原店OPEN！'},
        {date:'21/4/22',shopName:'セルフエステエンリケいわき店・博多店・川崎店OPEN！'},
        {date:'21/4/21',shopName:'セルフエステエンリケ米子店OPEN！'},
        {date:'21/4/20',shopName:'セルフエステエンリケ丸亀店・北千住店・札幌琴似店・沖縄コザ店・大和高田店OPEN！'},
        {date:'21/4/15',shopName:'セルフエステエンリケ小松店OPEN！'},
        {date:'21/4/5',shopName:'セルフエステエンリケ錦糸町店・江坂店OPEN！'},
        {date:'21/4/1',shopName:'セルフエステエンリケ仙台東口店・那覇店OPEN！'},
        {date:'21/3/31',shopName:'セルフエステエンリケ稲沢店・いわき鹿島店・刈谷店・甲府店・阿南店・一社店OPEN！'},
        {date:'21/3/26',shopName:'セルフエステエンリケ豊橋店OPEN！'},
        {date:'21/3/22',shopName:'セルフエステエンリケ川越店OPEN！'},
        {date:'21/3/21',shopName:'セルフエステエンリケ坂戸駅前店・清田店OPEN！'},
        {date:'21/3/20',shopName:'セルフエステエンリケ四条大宮店OPEN！'},
        {date:'21/3/12',shopName:'セルフエステエンリケ福岡香維店OPEN！'},
        {date:'21/3/8',shopName:'セルフエステエンリケ八王子店OPEN！'},
        {date:'21/3/7',shopName:'セルフエステエンリケ倉敷店・霧島店OPEN！'},
        {date:'21/3/6',shopName:'セルフエステエンリケ松本店・福井店・甲賀店・草加店OPEN！'},
        {date:'21/3/3',shopName:'セルフエステエンリケ熊本下通店OPEN！'},
        {date:'21/3/1',shopName:'セルフエステエンリケなんば店・岐阜店・各務原店・名古屋駅店OPEN！'},
        {date:'21/2/28',shopName:'セルフエステエンリケ東武宇都宮店OPEN！'},
        {date:'21/2/26',shopName:'セルフエステエンリケ大野城店OPEN！'},
        {date:'21/2/23',shopName:'セルフエステエンリケ宇都宮インターパーク店OPEN！'},
        {date:'21/2/22',shopName:'セルフエステエンリケ心斎橋店・長崎店・高岡店OPEN！'},
        {date:'21/2/15',shopName:'セルフエステエンリケ春日井店OPEN！'},
        {date:'21/2/13',shopName:'セルフエステエンリケ太田店・高松店OPEN！'},
        {date:'21/2/11',shopName:'セルフエステエンリケ岡山店・金沢駅西店OPEN！'},
        {date:'21/2/10',shopName:'セルフエステエンリケ大阪天満店OPEN！'},
        {date:'21/2/5',shopName:'セルフエステエンリケ下関店・吉祥寺店・会津若松店OPEN！'},
        {date:'21/2/2',shopName:'セルフエステエンリケ横浜東口店OPEN！'},
        {date:'21/2/1',shopName:'セルフエステエンリケ栄店・金山店・五所川原店OPEN！'},
        {date:'21/1/30',shopName:'セルフエステエンリケ札幌駅前店OPEN！'},
        {date:'21/1/27',shopName:'セルフエステエンリケつくば店OPEN！'},
        {date:'21/1/24',shopName:'セルフエステエンリケ長野店OPEN！'},
        {date:'21/1/16',shopName:'セルフエステエンリケ函館店・横浜西口店・宮崎店OPEN！'},
        {date:'21/1/11',shopName:'セルフエステエンリケ水戸店OPEN！'},
        {date:'21/1/8',shopName:'セルフエステエンリケ天文館店OPEN！'},
        {date:'21/1/3',shopName:'セルフエステエンリケ小倉北店OPEN！'},
        {date:'20/12/20',shopName:'セルフエステエンリケ仙台店OPEN！'},
        //{date:'21/1/',shopName:'セルフエステ公式HPリリース！'},
        //{date:'20/9/1',shopName:'店舗１'},
      ],
      settings: {
        maxScrollbarLength: 60
      },
    }
  },
  methods: {
    scrollHandle(evt) {
      console.log(evt);
    }
  }
}
</script>

<style scoped>
  .scroll-area {
    position: relative;
    margin: auto;
    width: 400px;
    height: 300px;
  }

  .new-topic-table{
    border-collapse: separate;
    border-spacing: 0 8px;
  }

  .new-topic-row{
    margin-bottom:10px;
  }

   /* PC表示 */
  @media screen and (min-width:821px){
    .new-topics-box{
      width: 65vw;

      left:0;
      right:0;
      margin:auto;  
    }

    .new-topics-title{
      font-size: 24px;

      width:100%;
      color: var(--main-color);
      border-bottom: solid 1px var(--main-color);

      margin-bottom: 8px;
      padding-bottom: 18px;
    }

  .new-date{
    font-size: 20px;
    /*width: 20%;*/
    background-color: var(--main-color);
    color: white;

    padding:10px 20px;
    margin: 100px;
  }

  .new-shop{
    font-size: 20px;

    color: var(--main-color);
    padding-left:30px;
  }

  }

  .movie-title{

    width:30vw;
    margin:0 auto;
    display:block;
  }

  .movie-img{

    width: 65vw;
    display: block;
    margin: 45px auto;
    margin-bottom: 80px;
  }

  .scroll{

    height: 200px;
    width: 100%;
    overflow: scroll;

  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    .new-topics-box{
      width: 90vw;
      /*  ↓ここweight追加  */
      font-weight:600;
      left:0;
      right:0;
      margin:auto;  
    }

    .new-topics-title{
      font-size: 16px;

      width:100%;
      color: var(--main-color);
      border-bottom: solid 1px var(--main-color);

      margin-bottom: 2px;
      padding-bottom: 8px;
    }

    .new-date{
      font-size: 15px;
      background-color: var(--main-color);
      color: white;
      font-weight:600;

      padding:8px 10px;
    }

    .new-shop{
      font-size: 15px;

      color: var(--main-color);
      padding-left:15px;
      line-height: 1.3em;
    }

    .movie-title{

    width:50vw;
    margin:0 auto;
    display:block;
  }

  .new-topic-table{

    padding-top: 10px;
  }

  .scroll{

    height: 150px;
    width: 100%;
    overflow: scroll;

  }

  .new-topic-row{

    padding-top: 10px;
  }
  }
</style>